import React from "react";
import { useNavigate } from "react-router-dom";
import './OperationsPage.css';
import TopNav from "../components/TopNav";
import UtcClock from "../components/UtcClock";

// The operationsCards array defines the features available on the Operations page.
// You can add, remove, or reorder these cards without breaking the layout.
// The Command Center layout uses a responsive grid of uniform cards.
const operationsCards = [
    {
        id: 1,
        title: "Jumpseat",
        description: "Instant crew relocation",
        link: "/jumpseat",
        icon: "✈",
        code: "JMP"
    },
    {
        id: 2,
        title: "Charters",
        description: "View and manage charter flights",
        link: "/charter-view",
        icon: "◉",
        code: "CHT"
    },
    {
        id: 4,
        title: "CAT II / III",
        description: "All weather operations",
        link: "/awo",
        icon: "◎",
        code: "AWO"
    },
    {
        id: 5,
        title: "Roster",
        description: "Pilot roster & status",
        link: "/roster",
        icon: "⊞",
        code: "RST"
    },
    {
        id: 7,
        title: "Documents",
        description: "Manuals & documentation",
        link: "/documents",
        icon: "☰",
        code: "DOC"
    },
    {
        id: 8,
        title: "ACARS",
        description: "Aircraft communications & reporting",
        link: "/acars",
        icon: "⊙",
        code: "ACS"
    },
    {
        id: 9,
        title: "Community",
        description: "Engage with the pilot community",
        link: "/community",
        icon: "⊕",
        code: "COM"
    },

    {
        id: 10,
        title: "Tours",
        description: "Curated flights with unique experiences",
        link: "/tours",
        icon: "◈",
        code: "TRS"
    },
    {
        id: 11,
        title: "Global Visas",
        description: "A showcase of world culture",
        link: "/visas",
        icon: "⊛",
        code: "VZA"
    },
    {
        id: 12,
        title: "Network Map",
        description: "An interactive visual representation of FDXVA global network",
        link: "/network-map",
        icon: "⁂",
        code: "MLT"
    }    ,
    {
        id: 13,
        title: "Manual PIREP",
        description: "Submit manual pilot reports",
        link: "/manual-flight-report",
        icon: "✏",
        code: "MAN"
    },    
];

const Operations = (props) => {
    const navigate = useNavigate();

    return (
        <React.Fragment>
            <TopNav page={props.page} darkMode={props.darkmode} />

            <div className={`ops-page ${props.darkmode ? 'dark-theme' : 'light-theme'}`}>
                <div className="ops-container">

                    {/* ── Header ───────────────────────────────────── */}
                    <header className="ops-header">
                        <div className="ops-title-wrapper">

                            <span className="ops-subtitle">Flight Operations</span>
                        </div>

                        <div className="ops-header-right">
                            <UtcClock />
                        </div>
                    </header>

                    {/* ── Command Grid ───────────────────────────────── */}
                    <div className="command-grid">
                        {operationsCards.map((card) => (
                            <div
                                key={card.id}
                                className="command-card"
                                onClick={() => navigate(card.link)}
                                role="button"
                                tabIndex={0}
                                onKeyDown={(e) => e.key === 'Enter' && navigate(card.link)}
                                aria-label={`Open ${card.title}`}
                            >
                                <div className="card-indicator"></div>
                                
                                <div className="card-icon-wrapper" aria-hidden="true">
                                    {card.icon}
                                </div>

                                <div className="card-content">
                                    <div className="card-header">
                                        <h3 className="card-title">{card.title}</h3>
                                        <span className="card-code">{card.code}</span>
                                    </div>
                                    <p className="card-description">{card.description}</p>
                                </div>

                                <div className="card-action" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                                    </svg>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </React.Fragment>
    );
};

export default Operations;
